import React from "react";

import "./RoundArrowIcon.scss";

export type RoundArrowIconProps = {
  disabled?: boolean;
  type: "left" | "right";
  cx?: string;
};

export const RoundArrowIcon: React.FC<RoundArrowIconProps> = ({
  cx = "",
  disabled = false,
  type,
}) => {
  return (
    <svg
      width="20"
      height="20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`RoundArrowIcon ${disabled} ${type} ${cx}`}
    >
      <circle cx="10" cy="10" r="10" fill="#fff" />
      <path d="m8 6 4 4-4 4" stroke="#111" strokeLinecap="round" />
    </svg>
  );
};
